<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-robot"></i> Configuração Bot</h3>
        <small>Horário de atendimento e mensagem fora do horário do bot por provedor.</small>
      </div>
    </div>
    <ModeloAdd v-if="showAdd" ref="ModeloAdd" v-on:Back="onBack" />
    <ModeloList v-else ref="ModeloList" v-on:New="onNew" v-on:Edit="onEdit" />
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ModeloAdd from './components/add/configuracaoBotadd.vue'
import ModeloList from './components/list/configuracaoBotConfigList.vue'

export default {
  name: 'ConfiguracaoBot',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    ModeloAdd,
    ModeloList
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  mounted () {
    Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.ModeloAdd.onAdd()
      })
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.ModeloAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/configuracaoBot/configuracaoBot.vue